import { render, staticRenderFns } from "./BaseNumberInput.vue?vue&type=template&id=534efa80&scoped=true"
import script from "./BaseNumberInput.vue?vue&type=script&lang=js"
export * from "./BaseNumberInput.vue?vue&type=script&lang=js"
import style0 from "./BaseNumberInput.vue?vue&type=style&index=0&id=534efa80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534efa80",
  null
  
)

export default component.exports